import ShimmerImage from 'core-lib/components/ShimmerImage';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import { Button } from 'ui-v2/components/Button';
import Icon from 'ui-v2/components/Icon/Icon';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import { LayoutEntityType, LayoutPropType } from '../../../types/layout';
import { trackCtaClickedStoreV2, trackSectionViewedStoreV2 } from '../../../utils/events';
import NewLaunchCard from '../../Cards/NewLaunchCard';
import s from './MarqueeListing.module.scss';

export const MarqueeListing = ({ data }: LayoutPropType) => {
  const { handleItemClick, handleItemClickWithDelegation } = useStoreItemClick();
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const length = data?.data?.length;

  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);

  return (
    <div
      className={s.root}
      ref={rootRef}
      style={
        data?.backgroundImage
          ? {
              backgroundImage: `url(${data.backgroundImage})`,
            }
          : {
              background: `${data?.backgroundColor}`,
            }
      }
      onClick={e => {
        handleItemClickWithDelegation(e, CARDID, data?.entityType, data?.data, data?.title);
      }}
    >
      <ShimmerImage src={data?.metaData?.headingImage} className={s.image} />
      <div className={s.list}>
        {data?.data.slice(0, length / 2 + (length % 2)).map((item, index) => (
          <NewLaunchCard
            key={item?.productId}
            data={item}
            id={CARDID}
            index={index}
            title={data?.title}
          />
        ))}
      </div>
      <div className={s.list}>
        {data?.data.slice(length / 2 + (length % 2)).map((item, index) => (
          <NewLaunchCard
            key={item?.productId}
            data={item}
            id={CARDID}
            index={Math.floor(index + length / 2 + (length % 2))}
          />
        ))}
      </div>
      <Button
        size="small"
        label={data?.ctaText || 'Explore all products'}
        fullWidth
        variant="link_color"
        rightIcon={<Icon name="ChevronRightRegular" color="brand" width={16} height={16} />}
        onClick={() => {
          trackCtaClickedStoreV2(data?.title, 'view_more_deals');
          handleItemClick(
            LayoutEntityType?.Category,
            data?.metaData?.categories?.[0]?.productId,
            data?.metaData?.categories?.[0]?.filter,
          );
        }}
      />
    </div>
  );
};
